import React from "react";
import styled, { keyframes } from "styled-components";
import Slider from "./Slider"; // Import your Slider component

// Define a common keyframes animation
const fadeInSlide = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Individual animated components with different delays
const AnimatedLabel = styled.div`
  opacity: 0;
  animation: ${fadeInSlide} 0.5s ease-out forwards;
  animation-delay: 0.2s;
  font-size: 16px;
  font-weight:500;
`;

const AnimatedSliderContainer = styled.div`
  margin-top: 0.5rem;
  opacity: 0;
  animation: ${fadeInSlide} 0.5s ease-out forwards;
  animation-delay: 0.4s;
`;

const AnimatedScaleLabelsContainer = styled.div`
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  opacity: 0;
  animation: ${fadeInSlide} 0.5s ease-out forwards;
  animation-delay: 0.6s;
`;


const Description = styled.div`
  font-weight:300;
  font-size:12px;
  margin-top:10px;
  font-family:'Raleway', sans-serif;

  opacity: 0;
  animation: ${fadeInSlide} 0.5s ease-out forwards;
  animation-delay: 0.2s;
`


const Qualifier = styled.div`
  font-size:16px;
  font-weight:bold;
  margin-bottom:10px;

  opacity: 0;
  animation: ${fadeInSlide} 0.5s ease-out forwards;
  animation-delay: 0.2s;
`

export default function QuestionLikert({ question, currentAnswer, onAnswerChange }) {
  // Extract the numeric scale (default to 5 if not provided)
  const scaleNum = question.properties.scale || 5;

  // Build a qualifier array that only shows labels at the endpoints and the middle.
  // For a scale of 5, indices 0, 2, and 4 will have the labels.
  const qualifier = Array.from({ length: scaleNum }, (_, i) => {
    if (i === 0) return question.properties.lowLabel || "";
    if (i === Math.floor(scaleNum / 2)) return "Neutral";
    if (i === scaleNum - 1) return question.properties.highLabel || "";
    return ""; // Empty strings for ticks that should not display any label.
  });

  // Format the question so the slider receives a scale string and the qualifier array.
  const formattedQuestion = {
    ...question,
    scale: `1-${scaleNum}`, // Slider expects a string like "1-5"
    qualifier: qualifier,
  };

  // Handler to pass the updated answer up to the parent
  const saveUpdatedAnswers = (val) => {
    onAnswerChange(question.uniqueId, val);
  };

  return (
    <div style={{ marginTop: "1rem" }}>
       {question.qualifier && <Qualifier>{question.qualifier}</Qualifier>}
      <AnimatedLabel>{question.question}</AnimatedLabel>
      {question.description && <Description>{question.description}</Description>}
      <AnimatedSliderContainer>
        <Slider
          id={question.uniqueId}
          question={formattedQuestion}
          saveUpdatedAnswers={saveUpdatedAnswers}
          currentQuestionDet={currentAnswer}
        />
      </AnimatedSliderContainer>
    </div>
  );
}
